<!-- Desktop variant -->
<section *ngIf="isDesktop" class="d-flex w-100 flex-wrap ps-lg-5">
  <figure class="m-0 p- ps-md-5 d-md-block d-none w-100">
    <picture>
      <img ngOptimizedImage [src]="imageSrc" class="landing-img-web" alt="" />
    </picture>
  </figure>
  <div class="helpline-web position-relative d-flex flex-wrap">
    <div class="col-md-12 col-12 px-3 center-align">
      <h2 class="mb-1 loginpage-caption-web bottomline">
        Need <b class="font-bolder">help?</b>
      </h2>
      <a class="phhelp phhelp-web" [href]="'tel:' + phoneNumber">{{ phoneDisplay }}</a>
      <p class="mt-2 horset horset-web" *ngFor="let h of hours">
        {{ h.label }} {{ h.time }}
      </p>
    </div>
  </div>
</section>

<!-- Mobile variant -->
<section *ngIf="!isDesktop" class="d-flex align-items-stretch w-100 flex-wrap ps-lg-5">
  <figure class="m-0 p- ps-md-5 d-md-block d-none w-100">
    <div class="bgmg position-relative">
      <img ngOptimizedImage [src]="imageSrc" class="ps-lg-5" alt="" />
    </div>
  </figure>
  <div class="helpline position-relative d-flex flex-wrap w-100">
    <div class="col-md-12 col-12 px-3 center-align">
      <h2 class="mb-3 loginpage-caption bottomline">
        Need <b class="font-bolder">help?</b>
      </h2>
      <a class="phhelp" [href]="'tel:' + phoneNumber">{{ phoneDisplay }}</a>
      <p class="mt-3 horset" *ngFor="let h of hours">
        {{ h.label }} {{ h.time }}
      </p>
    </div>
  </div>
</section>